<div class="option-content-particularity pointer" (click)="setIsContractFason()">
    <span class="option-title">Contrato Fasón</span>

    <div class="actions">
        <input type="checkbox" [checked]="isContractFason" class="checkbox"/>
    </div>
</div>